'use strict';

const commonHelpers = require('../helpers/commonHelpers');
let sptOptionSwitch = $('#spt-option-switch');
const $productContainer = $(sptOptionSwitch).closest('.product-detail');
const sptOptionsSelector = $productContainer
    .find('.product-option[data-option-id="SPT"]')
    .find('.options-select');

const $switchToCristales = $("#switch-to-cristales");
const $dataOptionIdSpt =  $('[data-option-id="SPT"]');

function toggleSptInsuranceContainer() {
    const isOnRecetaStep = $('.receta-step-block').is(':visible');
    const $sptInsuranceContainer = $('#spt-insurance-full-container');
    const homeStep = $('.pack-step-block').is(':visible');

    if(isOnRecetaStep) {
        $sptInsuranceContainer.addClass('d-none');
        $sptInsuranceContainer.removeClass('d-md-block');
    }else {
        $sptInsuranceContainer.removeClass('d-none');
        $sptInsuranceContainer.toggleClass('d-md-block', homeStep && !$sptInsuranceContainer.hasClass('optic'));
    }
}

/**
 * 
 */
function initPricesChangeEvents() {
    $('body').on('pdp:afterUpdateModalGLasessPrices', function() {
        let insuranceToApply = setPricesForInsuranceSelected();

        let sptOptionSwitch = $('#spt-option-switch');
        let sptOptionSwitchMobile = $('#spt-option-switch-mobile');
        // Change Total price
        if (sptOptionSwitch.prop("checked") || sptOptionSwitchMobile.prop("checked")) {
            updateTotal(insuranceToApply.priceValue);
        }
    });

    $('body').on('pdp:packNextStep', function() {
        toggleSptInsuranceContainer();
    });

    $('body').on('pdp:onBackRecetaStep pdp:onBackTratamientosStep', function() {
        const homeStep = $('.pack-step-block').css('display') === 'block';
        const $sptInsuranceContainer = $('#spt-insurance-full-container');

        if(homeStep) {
            $sptInsuranceContainer.addClass('d-none');
            if(!$sptInsuranceContainer.hasClass('optic')) {
                $sptInsuranceContainer.removeClass('d-md-block');
            }else {
                $sptInsuranceContainer.addClass('d-md-block');
            }
        }else {
            $sptInsuranceContainer.removeClass('d-none');
            $sptInsuranceContainer.addClass('d-md-block');
        }
    });   
}

function initPdp() {
    let isSunRx = $switchToCristales.length > 0 ? $switchToCristales.prop("checked") : false;
    if ($switchToCristales.length > 0 && !isSunRx) {
        $dataOptionIdSpt.hide();
    }

    $('body').on('pdp:changeSwitchToCristales', function() {
       if ($switchToCristales.prop("checked")) {
            $dataOptionIdSpt.show();
       } else {
            $dataOptionIdSpt.hide();
       }
    });

    $('body').on('product:afterAddToCart', function (ev, data) {
        // Reset options selector
        setSptOptionToNoValue();
    });
}

function setSptOptionToNoValue () {
    sptOptionsSelector.find('option').each(function(index, element){
        $(element).attr('selected', false);
        if ($(element).data('value-id') === 'no-spt') {
            $(element).prop('selected', true);
        }
     });
}

/**
 *
 */
function init() {
    initPdp();
    initSwitchSelector();
    modalOpenActions();
    initPricesChangeEvents();
};

function modalOpenActions() {
    $('#pdp__cristales-modal').on('shown.bs.modal', function (event) {
        setSptOptionToNoValue();

        if (sptOptionsSelector.find('option').length === 0) {
            $('#spt-insurance-full-container').hide();
            return;
        }   
 
       setPricesForInsuranceSelected();
       hideTotalValues()
    });
}

function hideTotalValues() {
     let sptOptionSwitch = $('#spt-option-switch');
    // Change Total price
    setPricesAndTotal(sptOptionSwitch.prop("checked"))
}

/**
 * Checks if a number falls within a specified range.
 * The start value is inclusive, and the end value is exclusive.
 *
 * @param {number} number The number to check.
 * @param {number} start The start of the range (inclusive).
 * @param {number} end The end of the range (exclusive).
 * @returns {boolean} True if the number is in the range, else false.
 */
function inRange(number, start, end) {
  // Ensure start is the lower bound and end is the upper bound
  // This handles cases where start > end
  if (start > end) {
    [start, end] = [end, start];
  }

  // Check if the number is greater than or equal to start, and less than end
  return number >= start && number < end;
}

/**
 *
 * @returns
 */
function getSptInsurancePrice() {
    let $insuranceSPTInfo = $('#spt-insurance-full-container')
    let insuranceToApply = null;
    
    if ($insuranceSPTInfo.length === 0) {
        return insuranceToApply;
    }

    let insuranceSPTInfo =  $insuranceSPTInfo.data('spt');

    // SPT tiers are configured against list prices. Since the modal started showing
    // campaign prices, product-cristal-value is discounted; the list value keeps the
    // tier selection identical to the pre-discount behaviour.
    let glassesPrices = $("[data-product-cristal]").data('product-cristal-list-value');

    if (glassesPrices === undefined || glassesPrices === null) {
        glassesPrices = $("[data-product-cristal]").data('product-cristal-value');
    }
    let totalValue = $("[data-main-product-price]").data('main-product-base-price');

    let totalSkuPlusGlasess = parseFloat(totalValue) + parseFloat(glassesPrices);
    
    // Get insurance price
    insuranceSPTInfo[0].values.forEach(function (insuranceData) {
        let range = insuranceData.rangesToApplyInsurance;
        let initRange = parseFloat(range.initRange);
        let lastRange = parseFloat(range.lastRange);

        if (inRange(totalSkuPlusGlasess, initRange, lastRange)) {
            insuranceToApply = insuranceData;
        }
    });
    
    return insuranceToApply;
}

function setDefaultOptionsSelect(insuranceToApply) {
    let sptOptionsSelector = $productContainer
        .find('.product-option[data-option-id="SPT"]')
        .find('.options-select');

    let optionSelectVal = null;
    sptOptionsSelector.find('option').each(function(index,element){        
        let idElement = $(element).attr('data-value-id');
        $(element).attr('selected', false);
        if (idElement === insuranceToApply.id) {
            optionSelectVal = $(element).attr('value');
        }
    });

    sptOptionsSelector.val(optionSelectVal);
}

function setPricesForInsuranceSelected() {
    let insuranceToApply = getSptInsurancePrice();

    if (!insuranceToApply) {
        return;
    }

    let $sptTitle = $('#spt-insurance-full-container')
    if($sptTitle.length === 0) {
        return;
    }

    let sptTitle = $sptTitle.data('spt-name');

    let sptOptionSwitch = $('#spt-option-switch');
    let sptOptionSwitchMobile = $('#spt-option-switch-mobile');

    // Set price to total and to SPT addon
    if (sptOptionSwitch.prop("checked") || sptOptionSwitchMobile.prop("checked")) {
        let $dataSptAddon = $("[data-spt-addon]");
        $dataSptAddon.text(sptTitle + ": " + commonHelpers.formatMoneyToClp(insuranceToApply.priceValue));
        $dataSptAddon.data('spt-value', insuranceToApply.priceValue);
    }

    // Set price to insurance price in modal
    $(".spt-insurance-price span").data('spt-insurance-price', insuranceToApply.priceValue);
    $("[data-spt-insurance-price]").text(commonHelpers.formatMoneyToClp(insuranceToApply.priceValue));
   
    return insuranceToApply;
}

function setPricesAndTotal(checked) {
        if (checked) {
            let $insuranceSPTInfo = $('#spt-insurance-full-container')
            if ($insuranceSPTInfo.length === 0) {
                return;
            }
            let insuranceSPTInfo = $insuranceSPTInfo.data('spt');

            if(!insuranceSPTInfo) {
                return;
            }
           
            let insuranceToApply = setPricesForInsuranceSelected();
            setDefaultOptionsSelect(insuranceToApply);

            // Change Total price
            updateTotal(insuranceToApply.priceValue);
        } else {
            // Remove from total
            let $dataSptAddon = $("[data-spt-addon]");
            let currentStpValue = parseInt($dataSptAddon.data('spt-value'));
            if (currentStpValue > 0) {
                $dataSptAddon.data('spt-value', 0);
                updateTotal(parseInt(currentStpValue) * -1);
                $dataSptAddon.text('');
            }
        }
}

function switchChangeHandler() {
    const checked = $(this).prop("checked");
    setPricesAndTotal(checked);
}


function initSwitchSelector() {
    let sptOptionSwitch = $('#spt-option-switch');
    sptOptionSwitch.on('change', switchChangeHandler);
    let sptOptionSwitchMobile = $('#spt-option-switch-mobile');
    sptOptionSwitchMobile.on('change', switchChangeHandler);
}

function updateTotal(priceValue) {
    let $dataSptAddon = $("[data-spt-addon]");
    let currenSptValue = parseInt($dataSptAddon.data('spt-value'));
    if (currenSptValue === undefined || currenSptValue === null || isNaN(currenSptValue) || currenSptValue === 0) {
        $dataSptAddon.data('spt-value', 0);
    }

    let $dataSubTotal = $("[data-subtotal]");

    let currentTotal = $dataSubTotal.attr('data-total-value');
    let currentTotalPlusSpt = parseInt(currentTotal) + parseInt(priceValue);

    $dataSubTotal.text(commonHelpers.formatMoneyToClp(currentTotalPlusSpt));
    $dataSubTotal.attr('data-total-value', currentTotalPlusSpt);

    // The footer reads Sub total - Descuento = Total. The insurance carries no discount,
    // so it has to be added to Sub total as well or the three lines stop reconciling.
    let $dataSubTotalList = $("[data-subtotal-list]");
    let currentListTotal = parseInt($dataSubTotalList.attr('data-list-total-value'), 10);

    if (!isNaN(currentListTotal)) {
        let listTotalPlusSpt = currentListTotal + parseInt(priceValue);
        $dataSubTotalList.text(commonHelpers.formatMoneyToClp(listTotalPlusSpt));
        $dataSubTotalList.attr('data-list-total-value', listTotalPlusSpt);
    }
}

module.exports = {
    init: init
};
